import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-card-testimonial',
  templateUrl: './card-testimonial.component.html',
  styleUrls: ['./card-testimonial.component.scss']
})
export class CardTestimonialComponent {

  @Input()
  name = ''

  @Input()
  company = ''

  @Input()
  image = '../assets/img/avatars/profiles/avatar-1.jpg'
}
